import { useMemo } from 'react'
import { com, kotlin } from '@eidu/form'
import { RenderablePath } from '../../pages/permission/path/PathField'
import getEntityPathLabel, { transformEntityPath } from '../../pages/permission/path/EntityPathUtils'
import findPathsBetweenTypes = com.eidu.sharedlib.entity.path.findPathsBetweenTypes
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import KtList = kotlin.collections.KtList

const useRenderablePaths = (
  entityTypeId: EntityTypeId,
  targetType: EntityType | undefined,
  entityTypes: readonly EntityType[]
) => {
  const paths = useMemo(() => {
    if (!targetType || !entityTypeId) return []
    return findPathsBetweenTypes(KtList.fromJsArray(entityTypes), entityTypeId, targetType.id).asJsReadonlyArrayView()
  }, [entityTypes, entityTypeId, targetType?.id])

  const renderablePaths: RenderablePath[] = useMemo(() => {
    if (paths.length === 0) return []
    return paths
      .slice()
      .sort((a, b) => a.edges.asJsReadonlyArrayView().length - b.edges.asJsReadonlyArrayView().length)
      .map((entityPath) => ({
        entityPath,
        entityPathLabel: getEntityPathLabel(entityTypes, entityPath),
        entityPathNodes: transformEntityPath(entityTypes, entityPath),
      }))
  }, [paths, entityTypes])

  return renderablePaths
}

export default useRenderablePaths
